import React from 'react';
import './RadioButton.css';
import ReviewFormattedMessage from './ReviewFormattedMessage';

export default function RadioButton ({label, value, valueKey, handleChange}) {

  return (
    <div className="RadioButton" >
      <div className="RadioButton-wrap">
        <input className="RadioButton-hidden RadioButton-radio-label RadioButton-choice-button" 
                type="radio" 
                checked={value === valueKey} 
                value={valueKey}
                id={valueKey} 
                onChange={handleChange}
                />
          <label className="RadioButton-button-label" htmlFor={valueKey}>
            <h1><ReviewFormattedMessage descriptor={label} /></h1>
          </label>
      </div>
    </div>
  );

}

